import React, { useContext } from "react";
import "./Footer.scss";
import StyleContext from "../../contexts/StyleContext";

const Footer = () => {
  const { isDark } = useContext(StyleContext);

  return (
    <footer className={`footer ${isDark ? 'dark-mode' : ''}`}>
      <div className="footer-content">
        <p className="footer-text">
          &copy; {new Date().getFullYear()}. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
